import PortableText from "./PortableText";

export default PortableText;
